import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { IEstatusJson } from '../../../authmanagement/models/IEstatusJson';
import { CustomerDTO } from '../../models/Customers/CustomerDTO';
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';

@Injectable({
  providedIn: 'root'
})
export class CustomersAPIService implements IApiBase{
  configUrl: string;

    constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

  public getRefererClient() {
    console.log("/api/Customer/GetbyClientId/");
    return this.http.post<IEstatusJson>(
      this.configUrl + "/api/Customer/GetbyClientId",
      { observe: "response" }
    );
  }

  public getAll() : any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Customer", {});
  }

  getCustomerById() {
    console.log("/api/Customer/GetByClientId/");
    return this.http.post<any>(this.configUrl + "/api/Customer/GetByClientId", {
      observe: "response",
    });
  }

  getDataGPSCitronellaById() {
    console.log("/api/Customer/GetGPSDataByClientId/");
    return this.http.post<any>(
      this.configUrl + "/api/Customer/GetGPSDataByClientId",
      { observe: "response" }
    );
  }
}
